import { useQuery } from "@tanstack/react-query";
import { useEffectiveCustomerId } from "@/hooks/useEffectiveCustomerId";
export function useCustomerQueryScope() {
    const { userRole, isSuperAdmin, effectiveCustomerId, customerIdentifier, isViewingAllOrgs, hasResolvedCustomerSelection } = useEffectiveCustomerId();
    if (!userRole || !hasResolvedCustomerSelection) {
        return {
            customerId: undefined,
            queryKey: "unresolved",
            enabled: false,
            isViewingAllOrgs: false
        };
    }
    if (!isSuperAdmin && !customerIdentifier) {
        return {
            customerId: undefined,
            queryKey: "unresolved",
            enabled: false,
            isViewingAllOrgs: false
        };
    }
    if (isViewingAllOrgs) {
        return {
            customerId: undefined,
            queryKey: "all-orgs",
            enabled: true,
            isViewingAllOrgs: true
        };
    }
    const scopedCustomerId = effectiveCustomerId ?? customerIdentifier;
    if (!scopedCustomerId) {
        return {
            customerId: undefined,
            queryKey: "unresolved",
            enabled: false,
            isViewingAllOrgs: false
        };
    }
    return {
        customerId: isSuperAdmin ? effectiveCustomerId : undefined,
        queryKey: scopedCustomerId,
        enabled: true,
        isViewingAllOrgs: false
    };
}
export function useCustomerScopedQuery({ queryKey, queryFn, enabled = true, ...options }) {
    const scope = useCustomerQueryScope();
    return useQuery({
        ...options,
        queryKey: [
            ...queryKey,
            scope.queryKey
        ],
        queryFn: ()=>queryFn(scope),
        enabled: enabled && scope.enabled
    });
}
